import { useEffect, useRef, useState } from 'react';
import { Download, Loader2, Play } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { VoiceMessagePlayer } from './VoiceMessagePlayer';
import { downloadWallFile, fileSize } from '../prospect/attachments/fileActions';

export const LazyProjectAudio = ({ projectId, file, client }) => {
    const [url, setUrl] = useState(null), [busy, setBusy] = useState(false), [error, setError] = useState(null);
    const resource = useRef({ abort: null, url: null });
    useEffect(() => () => { resource.current.abort?.abort(); if (resource.current.url) URL.revokeObjectURL(resource.current.url); }, []);
    const play = async () => {
        if (busy) return;
        const abort = new AbortController(); resource.current.abort = abort;
        setBusy(true); setError(null);
        try {
            const response = await client.download(projectId, file.id, abort.signal);
            if (abort.signal.aborted) return;
            resource.current.url = URL.createObjectURL(response.data); setUrl(resource.current.url);
        } catch { if (!abort.signal.aborted) setError('Lecture indisponible. Réessayez.'); }
        finally { if (!abort.signal.aborted) setBusy(false); }
    };
    const download = async () => {
        try { await downloadWallFile(projectId, file, undefined, client); }
        catch { setError('Téléchargement indisponible.'); }
    };
    return <div className="mt-2 max-w-md" data-testid={`pw-att-${file.id}`}>
        {url ? <VoiceMessagePlayer blobUrl={url} seed={file.id} autoPlay filename={file.filename} onDownload={download} testIdPrefix={`pw-voice-${file.id}`} /> :
            <div className="flex items-center gap-2 rounded-md border border-slate-200/70 bg-slate-50/60 px-2 py-1.5">
                <Button type="button" variant="ghost" size="icon" onClick={play} disabled={busy} title="Écouter le vocal" aria-label="Écouter le vocal" data-testid={`pw-audio-play-${file.id}`}>{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Play className="h-4 w-4" />}</Button>
                <div className="min-w-0 flex-1"><p className="truncate text-xs text-slate-600" title={file.filename} data-testid={`pw-audio-name-${file.id}`}>{file.filename}</p><p className="text-[10px] text-slate-400" data-testid={`pw-audio-size-${file.id}`}>{fileSize(file.size)}</p></div>
                <Button type="button" variant="ghost" size="icon" onClick={download} title="Télécharger" aria-label="Télécharger le vocal" data-testid={`pw-audio-download-${file.id}`}><Download className="h-4 w-4" /></Button>
            </div>}
        {error && <p role="alert" className="text-xs text-red-600" data-testid={`pw-audio-error-${file.id}`}>{error}</p>}
    </div>;
};